import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconControllerButtonSquare: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="controller-button-square, view, panel"><circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/><rect x="7.75" y="7.75" width="8.5" height="8.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconControllerButtonSquare;
